import { useHealthCheck } from '@hooks/useHealthCheck.ts';

const HealthCheckGuard = () => {
    useHealthCheck();
    return null;
};

export default HealthCheckGuard;
